import { registerTab } from "lib/@components/tabs"
import { isEnabled } from "lib/@components/feature"
import { hasDemand } from "lib/authorization/has-demand"
import { FEATURE_FLAG_CONTENT_TRANSLATION } from "routes/schedule/plugins/translation/translation.runtime"
import { BatchTranslateCustomPanel } from "./batch-translate-custom-panel"

registerTab({
    tab: "clientAdmin",
    id: "batchTranslate",
    title: "Batch Translate",
    content: <BatchTranslateCustomPanel $lazy />,
    predicate: () => hasDemand("clientAdmin") && isEnabled(FEATURE_FLAG_CONTENT_TRANSLATION),
})
